import React from 'react';
import {TextField as MuiTextField, TextFieldProps} from '@mui/material';
import classes from './textField.module.scss';
import clsx from "clsx";

export const TextField = (props: TextFieldProps) => {
  return (
    <MuiTextField
      variant="outlined"
      margin="none"
      fullWidth
      className={clsx(classes.textInput, 'joint-text-input')}
      {...props}
    />
  );
};

export default TextField;